module.exports = __webpack_public_path__ + "img/h5-岗位匹配度.b296ab7b.svg";